import { useGetFeatureFlags } from "../_actions/bot";

/**
 * Custom hook to consume feature flags efficiently.
 * It will use React Query cache behind the scenes.
 * 
 * @param {string} flagName - The key of the feature flag (e.g. "ai_chat", "spotlight").
 * @param {boolean} defaultValue - The default boolean value if the request has not resolved or key is missing.
 * @returns {boolean} - Whether the feature flag is enabled.
 */
export const useFeatureFlag = (flagName, defaultValue = false) => {
    const { data: featureFlags } = useGetFeatureFlags();

    if (!featureFlags) {
        return defaultValue;
    }

    // Default to the provided defaultValue if flagName does not exist
    return featureFlags[flagName] ?? defaultValue;
};
